import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row justify-between full-width q-px-xs items-center" }
const _hoisted_2 = { key: 0 }

import { computed, ref } from 'vue';

import FloatingWindow from 'SharedComponents/ui/File/FloatingWindow.vue';
import SIcon from 'SharedComponents/ui/Icon/SIcon.vue';
import useCustomLoading from 'SharedDir/common/composables/useCustomLoading';
import useFileApi from 'SharedDir/common/composables/useFileApi';
import { makeRequest } from 'SharedDir/common/composables/useRequests';
import FilePreview from 'SharedDir/components/ui/File/FilePreview.vue';
import { previewKnowFiles } from 'SharedDir/constants/files';
import { AttachmentType } from 'SharedDir/declarations/files';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'FileListItem', components: { FilePreview } },
  __name: 'FileListItem',
  props: {
    data: {},
    readonly: { type: Boolean },
    previewInWindow: { type: Boolean }
  },
  emits: ["remove"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const { downloadFile } = useFileApi();
const { loading, requestOptions } = useCustomLoading();
const documentName = computed(() => {
  if (props.data.extension) {
    return `${props.data.name}.${props.data.extension}`;
  }
  return props.data.name;
});

const knowFiles = [
  'bmp',
  'csv',
  'doc',
  'docx',
  'jpg',
  'ods',
  'pdf',
  'png',
  'ppt',
  'rar',
  'rtf',
  'sig',
  'txt',
  'xlsx',
  'xml',
  'zip',
];

const ext = computed(() => {
  if (props.data.extension) {
    return props.data.extension.toLowerCase();
  }
  return '';
});

const iconName = computed(() => {
  if (ext.value && knowFiles.includes(ext.value)) {
    return `custom:files/${ext.value}`;
  }

  return 'custom:files/unknown';
});

const showPreview = computed(() => {
  return previewKnowFiles.includes(ext.value);
});

const documentPreviewVisibility = ref(false);
const previewIcon = computed(() => (documentPreviewVisibility.value ? 'app:eye-close' : 'app:eye'));

const documentPreviewVisibilitySwitch = () => {
  documentPreviewVisibility.value = !documentPreviewVisibility.value;
};

async function download() {
  await makeRequest(() => downloadFile(props.data.id), requestOptions);
}

const previewContainer = computed(() => (props.previewInWindow ? FloatingWindow : 'div'));

const previewBind = computed(() => ({
  title: documentName,
  size: ext.value === 'pdf' ? undefined : { height: 750, width: 875 },
  onClose: documentPreviewVisibilitySwitch,
}));

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "row justify-start items-center cursor-pointer no-wrap s-link q-py-sm col-10",
        onClick: download
      }, [
        _createVNode(SIcon, {
          class: "s-mr-md",
          name: iconName.value,
          size: "large"
        }, null, 8, ["name"]),
        _createElementVNode("span", null, _toDisplayString(documentName.value), 1)
      ]),
      (_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Загрузка"))
        : _createCommentVNode("", true),
      (!_unref(loading) && !_ctx.readonly)
        ? (_openBlock(), _createBlock(SIcon, {
            key: 1,
            class: "col-1",
            size: "large",
            color: "brand",
            name: "app:delete-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('remove')))
          }))
        : _createCommentVNode("", true),
      (showPreview.value)
        ? (_openBlock(), _createBlock(SIcon, {
            key: 2,
            class: "col-1",
            color: "grey",
            name: previewIcon.value,
            onClick: documentPreviewVisibilitySwitch
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(documentPreviewVisibility.value ? 'Закрыть' : 'Открыть') + " предварительный просмотр ", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["name"]))
        : _createCommentVNode("", true)
    ]),
    (documentPreviewVisibility.value)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(previewContainer.value), _normalizeProps(_mergeProps({ key: 0 }, previewBind.value)), {
          default: _withCtx(() => [
            _createVNode(FilePreview, { fileData: _ctx.data }, null, 8, ["fileData"])
          ]),
          _: 1
        }, 16))
      : _createCommentVNode("", true)
  ], 64))
}
}

})